import classNames from "classnames";
import * as React from "react";

type ClsAndChildProps = {className?: string; children?: React.ReactNode};

export const D4 = ({className, children}: ClsAndChildProps) => {
    return <div className={classNames('d4', className)}>{children}</div>;
};
